module.exports = __webpack_public_path__ + "static/img/img_guide4.0c0ed7bc.png";